import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';
import {
  FDConfirmationDialog, FDPrimaryActionButton, FDSecondaryActionButton, FDStack, FDTableCell, FDTableRow,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React from 'react';
import { dataAttrs } from 'Helpers/Testing';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';

export const SolutionTableRow = ({ isPlural, submitSolution }) => {
  const { resource } = useMetaLayoutContext();

  const {
    dialogOpen,
    loading,
    handleClose,
    handleSubmit,
    handleOpen,
  } = useConfirmationDialogState({
    closeOnSubmit: true,
    onSubmit: () => { submitSolution(resource, 'false'); },
  });

  const fineTuneSubmit = async () => {
    await submitSolution(resource, 'true');
  };

  return (
    <>
      <FDTableRow key={resource.id()} {...dataAttrs('retirement-age-goal-seek-result-row')}>
        <FDTableCell {...dataAttrs('retirement-age-goal-seek-primary-client-suggested-age')}>
          <MetaControlField attr={'primaryClientRetirementValue'} />
        </FDTableCell>
        {isPlural && <>
          <FDTableCell {...dataAttrs('retirement-age-goal-seek-spouse-client-suggested-age')}>
            <MetaControlField attr={'spouseClientRetirementValue'} />
          </FDTableCell>
        </>}
        <FDTableCell>
          <MetaControlField attr={'endBalanceDisplay'} />
        </FDTableCell>
        <FDTableCell>
          <FDStack direction={'row'} spacing={2} justifyContent={'center'}>
            <FDPrimaryActionButton
              onClick={handleOpen}
              size={'sm'}
              label={resource.attr('useButtonLabel')}
              test={'retirement-age-goal-seek-use-value'}
            />
            <FDSecondaryActionButton
              onClick={fineTuneSubmit}
              size={'sm'}
              label={'Fine-tune'}
              test={'retirement-age-goal-seek-fine-tune-value'}
            />
          </FDStack>
        </FDTableCell>
      </FDTableRow>
      <FDConfirmationDialog
        message={isPlural
          ? 'This will update the members\' Retirement Outcome ages with the selected values.'
          : 'This will update the member\'s Retirement Outcome age with the selected value.'}
        title={'Are you sure?'}
        onClose={handleClose}
        onConfirm={handleSubmit}
        loading={loading}
        open={dialogOpen}
      />
    </>
  );
};

SolutionTableRow.propTypes = {
  isPlural: PropTypes.bool.isRequired,
  submitSolution: PropTypes.func.isRequired,
};

export const SolutionRowOverrides = buildFacetDesignOverride()
  .nameOverride(['primaryClientRetirementValue', 'spouseClientRetirementValue', 'endBalanceDisplay'], {
    _component: () => BodyTextMedium,
  }, overrideReadOnly);
